import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldTrim extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'trim');
  }
}
